import {
	Stack,
	Checkbox,
	Typography,
	useTheme,
	useMediaQuery,
} from '@mui/material';

import React from 'react';

import ButtonComp from 'common/components/Button/ButtonComp';
import { APPLICABILITY_STATUS } from 'common/constants/CitationDetails';

import { ICitationDetailsElements } from '../../api/type-def';

import styles from './SubCitationSummary.module.scss';

const { textBoxColor } = styles;

const { APPLICABLE, NOTAPPLICABLE, INFORMATIONAL } = APPLICABILITY_STATUS;

export interface CitationSummary {
	checkedCitations: ICitationDetailsElements[];
	selectedAccordians: ICitationDetailsElements[];
	res: ICitationDetailsElements;
	handleCheckBox?: any;
	handleClick?: any;
	isCheckBoxRequired: boolean;
	enableApplicablityStatus: boolean;
	isTaskidPresent: boolean;
	handleAccordionText?: (res: any, event: React.SyntheticEvent) => void;
}
const SubCitationSummary = (citation: CitationSummary) => {
	const {
		checkedCitations,
		selectedAccordians,
		res,
		handleCheckBox,
		isCheckBoxRequired,
		handleClick,
		enableApplicablityStatus,
		isTaskidPresent,
		handleAccordionText,
	} = citation;

	const citationEmptyComment: ICitationDetailsElements = {
		...res,
		applicabilityComments: '',
	};
	const theme = useTheme();
	const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

	const handleTextCLick = (rvalue: any, event: any) => {
		event.stopPropagation();
		if (handleAccordionText) {
			handleAccordionText(rvalue, event);
		}
	};

	const label = {
		inputProps: { 'aria-label': 'Checkbox demo', 'data-testid': 'checkbox' },
	};
	return (
		<Stack
			direction={isSmallScreen ? 'column' : 'row'}
			justifyContent="space-between"
			width="100%"
		>
			<Stack direction="row" alignItems="center">
				{isCheckBoxRequired && enableApplicablityStatus && (
					<Checkbox
						data-testid="inventory-details"
						{...label}
						size="small"
						checked={checkedCitations.includes(res)}
						onChange={(event) => handleCheckBox(event, res)}
						sx={{
							'&.Mui-checked': {
								color: textBoxColor,
							},
						}}
					/>
				)}
				<Typography
					className={styles['inventory-citation-heading']}
					data-testid="title"
					onClick={(event) => {
						handleTextCLick(res, event);
					}}
				>
					{res.description}
				</Typography>
			</Stack>
			{selectedAccordians.includes(res) &&
			enableApplicablityStatus &&
			isTaskidPresent ? (
				<Stack
					direction={isSmallScreen ? 'column' : 'row'}
					alignItems="center"
					justifyContent="end"
					gap="10px"
					paddingTop={isSmallScreen ? '4px' : '0px'}
				>
					<ButtonComp
						btnType="primary"
						data-testid={APPLICABLE}
						compClass={
							res.applicabilityStatus === APPLICABLE
								? styles['inventory-applicable-section-selected']
								: styles['inventory-applicable-section-not-selected']
						}
						clickHandler={handleClick(citationEmptyComment, APPLICABLE)}
					>
						{APPLICABLE}
					</ButtonComp>
					<ButtonComp
						btnType="secondary"
						data-testid={NOTAPPLICABLE}
						compClass={
							res.applicabilityStatus === NOTAPPLICABLE
								? styles['inventory-applicable-section-selected']
								: styles['inventory-applicable-section-not-selected']
						}
						clickHandler={handleClick(res, NOTAPPLICABLE)}
					>
						{NOTAPPLICABLE}
					</ButtonComp>
					<ButtonComp
						btnType="secondary"
						data-testid={INFORMATIONAL}
						compClass={
							res.applicabilityStatus === INFORMATIONAL
								? styles['inventory-applicable-section-selected']
								: styles['inventory-applicable-section-not-selected']
						}
						clickHandler={handleClick(citationEmptyComment, INFORMATIONAL)}
					>
						{INFORMATIONAL}
					</ButtonComp>
				</Stack>
			) : (
				<Stack direction="row" alignItems="center">
					<Typography
						className={styles['inventory-applicable-text']}
						data-testid="collapsed"
					>
						{res.applicabilityStatus}
					</Typography>
				</Stack>
			)}
		</Stack>
	);
};

export default SubCitationSummary;
